module.exports = __webpack_public_path__ + "assets/media/2.fbfa9a55.wav";